import * as MEDICINE from '@/store/constants/medicine';
import {mapActions} from 'vuex';

export default {
  name: 'MedicineDetail',
  data() {
    return {
      medicine: {}
    }
  },
  methods: {
    ...mapActions({
      delete: MEDICINE.ACTION_DELETE
    }),

    handleDelete() {
      this.delete(this.medicine)
        .then((res) => {
          this.backToList();
        }).catch((err) => {
        console.log(err);
      });
    },

    backToList() {
      this.$router.push({name: 'MedicineList'});
    }
  },
  created() {
    if (this.$route.params['medicine']) {
      this.medicine = this.$route.params['medicine'];
    } else {
      this.backToList();
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/Medicine/js/medicine-detail.js